module.exports = __webpack_public_path__ + "static/assets/e4e59b069a1264c0cb0a546577913f88.svg";